import { render, staticRenderFns } from "./pharmacyPerformance.vue?vue&type=template&id=5728e5a4&scoped=true"
import script from "./pharmacyPerformance.vue?vue&type=script&lang=js"
export * from "./pharmacyPerformance.vue?vue&type=script&lang=js"
import style0 from "./pharmacyPerformance.vue?vue&type=style&index=0&id=5728e5a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5728e5a4",
  null
  
)

export default component.exports